module.exports = __webpack_public_path__ + "img/music_006.2190f3c8.png";